
import Images from '../../state/stores/Image/images';
import PressableScale from '../PressableScale/PressableScale';
import React from 'react';
import { Animated, Image, StyleSheet, View } from 'react-native';
import { CIRCLE_MARGIN, CIRCLE_SIZE } from '../../config/designSystem/Colors';
import { Feather, MaterialCommunityIcons } from '@expo/vector-icons';
import { FlatListItemProps } from '../../types/navigation';
import { ParagraphLBold, ParagraphMRegular } from '../../config/designSystem/typography';
import { REGULAR_HORIZONTAL_MARGIN_FN, isWeb } from '../../config/designSystem/Layout';
import { useAvailableDimensions } from '../../hooks/ui/useAvailableDimensions';



const colors= [
  '#D1E7FB',
  '#FFD5C8',
  '#D2EFE8',
  '#D8B6F2',
  '#BAC6F2'
];






export const CompanyAssistanceItem = ({ item }: FlatListItemProps) => {
  const { width } = useAvailableDimensions();
  const INDEX = item?.index? item.index:0;
  const styles = StyleSheet.create({
    itemContainer: {
      margin: 20,
      marginBottom: 0,
      backgroundColor: '#fff',
      borderRadius: 12,
      shadowColor: '#000',
      alignSelf: 'stretch',
      shadowOffset: {
        width: 0,
        height: 2,
      },
      shadowOpacity: 0.1,
      shadowRadius: 3.84,
      elevation: 5,
      width: Math.min(width - 2 * REGULAR_HORIZONTAL_MARGIN_FN(width), 400),
      marginHorizontal: REGULAR_HORIZONTAL_MARGIN_FN(width),
    },
    topContainer: { flexDirection: 'row', alignItems: 'center', marginBottom: 10, justifyContent:'space-between' },

    center: { alignItems: 'center', flex:1 },
    marginTopSmall: { marginTop: 2 },
    marginRightSmall:{marginRight:10},
    innerImage: {
      width: item.image.size ? item.image.size : CIRCLE_SIZE,
      height: item.image.size ? item.image.size : CIRCLE_SIZE,
      margin: CIRCLE_MARGIN,
      borderRadius: item.image.size ? item.image.size : CIRCLE_SIZE,

    },
    backgroundImage: {
      borderRadius: 12,
      overflow: 'hidden',
      backgroundColor: colors[INDEX%colors.length]
    }
  });
  const scaleAnimation = React.useRef(new Animated.Value(1)).current;
  const rightSideLogo = (logo: any) => {
    if (logo.type === 'Feather') {
      return <Feather name={logo.name} size={logo.size} style={styles.marginRightSmall} color={logo.color} />;
    }
    if (logo.type === 'MaterialCommunityIcons') {
      return (
        <MaterialCommunityIcons name={logo.name} size={logo.size} style={styles.marginRightSmall} color={logo.color} />
      );
    }
  };
  const factorResize = isWeb?5:10;

  return (
    <PressableScale scaleAnimation={scaleAnimation} onPress={item.onPress} style={{ flex: 1 }}>
      <Animated.View
        style={[
          styles.itemContainer,
          {
            transform: [{ scale: scaleAnimation }],
          },
          isWeb && { width:'70vw', minWidth: 250},
        ]}
      >
        <View style={styles.backgroundImage}>
          <View style={styles.topContainer}>
            <View style={{flex:1}}>
              <Image
                source={item.image.fromStore ? Images[item.image.storeName][item.image.imageName] : { uri: item.image.uri }}
                style={[
                  styles.innerImage,
                  {
                    backgroundColor: item.color,
                  },
                ]}
              />
            </View>
            <View style={{justifyContent:'center', alignItems: 'center',flex:5}}>
              <ParagraphLBold>{item.title}</ParagraphLBold>
            </View>
            <View style={styles.center}>{rightSideLogo(item.logo)}</View>
          </View>
          <View style={{marginBottom:15, marginLeft: 25, paddingLeft:5}}>
            <ParagraphMRegular>{item.description}</ParagraphMRegular>
          </View>
          <View style={{position:'absolute', right:0, bottom:0,  alignItems:'flex-end', justifyContent:'flex-end'}}>
            <Image
              source={item.background.fromStore ? Images[item.background.storeName][item.background.backgroundName] : { uri: item.background.uri}}
              style={[{ paddingBottom:10,width:680/10, height: 512/10,  zIndex:-10}]}
              width={680/factorResize}
              height={512/factorResize}
              resizeMethod='scale'
              resizeMode='stretch'
            />
          </View>
        </View>

      </Animated.View>
    </PressableScale>
  );
};
